import React from 'react';
import './percentageCard.css';

const PercentageCard = ({ title, total, mainValue, mainClass, vehiclesStatus }) => {
    const active = vehiclesStatus?.filter(vehicle => vehicle.status === 'activo').length || 0;
    const inactive = vehiclesStatus?.filter(vehicle => vehicle.status === 'inactivo').length || 0;

    // Cálculo de la longitud de la circunferencia
    const radius = 36;
    const circumference = 2 * Math.PI * radius;

    const percentage = total > 0 ? (vehiclesStatus ? active : mainValue) * 100 / total : 0;

    // Cálculo de strokeDashoffset basado en el porcentaje
    const offset = isNaN(circumference - (percentage / 100) * circumference)
        ? 0
        : circumference - (percentage / 100) * circumference;


    return (
        <div className='card percent'>
            <div className='card_content'>
                <div>
                    <h2>{title}</h2>
                    <div className='info'>
                        <h1 className={mainClass}>{mainValue}</h1>
                        {vehiclesStatus !== undefined && (
                            <>
                                <div className='status'>
                                    <span className='dot green'></span><h3 className='success'>{active} activos</h3>
                                </div>
                                <div className='status'>
                                    <span className='dot red'></span><h3 className='danger'>{inactive} inactivos</h3>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className='progresss'>
                    <svg>
                        <circle
                            cx='38'
                            cy='38'
                            r='36'
                            style={{
                                strokeDasharray: circumference,
                                strokeDashoffset: 0,
                                transform: 'rotate(-90deg)',
                                transformOrigin: '47% 40%',
                                stroke: `var(--color-${mainClass})`,
                                opacity: 0.3
                            }}
                        ></circle>
                        {/* Progreso principal */}
                        <circle
                            cx='38'
                            cy='38'
                            r='36'
                            style={{
                                strokeDasharray: circumference,
                                strokeDashoffset: isNaN(offset) ? 0 : offset,
                                transform: 'rotate(-90deg)',
                                transformOrigin: '47% 40%',
                                className: 'danger',
                                stroke: `var(--color-${mainClass})`
                            }}
                        ></circle>
                    </svg>
                    <div className='percentage'>
                        <p>{percentage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PercentageCard;
